<template>
    <iframe
        :ref="(e) => (refs.iframe = e)"
        :width="width"
        :height="data.iframeStyle.height"
        :frameborder="frameborder"
        :scrolling="scrolling"
        :src="src"
    ></iframe>
</template>

<script>
import { defineComponent, onMounted, reactive } from "vue";
import { state as stateAppLayout } from "../layout/app-layout/app-layout.logic";
import { useStore } from "vuex";

export default defineComponent({
    components: {},
    props: {
        width: { default: "100%" },
        height: { default: "300" },
        frameborder: { default: "0" },
        scrolling: { default: "no" },
        src: {},
    },
    emits: ["iframeMounted"],
    setup(props, { emit }) {
        const store = useStore();
        const refs = reactive({ iframe: null });
        const data = reactive({
            iframeStyle: {
                height: `${props.height}px`,
            },
        });
        onMounted(() => {
            refs.iframe.contentWindow.menuSides = stateAppLayout.menuSides;
            refs.iframe.contentWindow.serverInfo = store.state.resource.server.info;
            refs.iframe.contentWindow.authInfo = store.state.resource.auth.info;
            emit("iframeMounted", { refs });
            setInterval(() => {
                const documentElement = refs.iframe?.contentWindow?.document?.documentElement;
                const appHeight = documentElement?.querySelector("#app")?.scrollHeight;
                const modalHeight = documentElement?.querySelector(".ant-modal-wrap")?.scrollHeight;
                //data.iframeStyle.height = `${refs.iframe?.contentWindow?.document?.documentElement?.scrollHeight || props.height}px`;
                data.iframeStyle.height = `${modalHeight || appHeight || props.height}px`;
            }, 250);
        });
        return { refs, data };
    },
});
</script>
